import filter from 'lodash/fp/filter';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';

/**
 * Filters features by layer, then maps each to an expandClusterFeatures promise.
 * @param {Array} features - Array of map features
 * @param {Function} layerFilter - Filter function for layers
 * @param {Function} expandFn - Function to expand cluster features (receives a feature, returns a promise)
 * @returns {Array} Array of promises
 */
export function filterAndExpandFeatures(features, layerFilter, expandFn) {
  return flow([filter(layerFilter), map((f) => expandFn(f))])(features);
}

/**
 * Filters features by layer, filters by polygon intersection, then maps to expandClusterFeatures promises.
 * @param {Array} features - Array of map features
 * @param {Function} layerFilter - Filter function for layers
 * @param {Function} intersectFilter - Filter function for polygon intersection
 * @param {Function} expandFn - Function to expand cluster features (receives a feature, returns a promise)
 * @returns {Array} Array of promises
 */
export function filterByPolygonAndExpand(features, layerFilter, intersectFilter, expandFn) {
  return flow([filter(layerFilter), filter(intersectFilter), map((f) => expandFn(f))])(features);
}
